import { CustomerDTO } from '@reactivereality/cs-api-sdk';
import { Observable } from 'rxjs';

export abstract class ICustomerService {
  abstract readonly currentCustomer: () => Promise<CustomerDTO>;
  abstract readonly currentCustomer$: Observable<CustomerDTO>;
  abstract readonly myCustomers$: Observable<Array<CustomerDTO>>;
}
